import API from 'API';

export const validateUniqueName = async (name) => {
  if (!name) {
    return 'Name is required';
  } else if (await API.find(`teams/validateUniqueName`, {name})) {
    return 'Name already exists';
  } else {
    return '';
  }
};

export const findTeams = async () => API.find('teams/');

export const save = (team) => API.save('teams/', team);
